import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-shopify-product',
  templateUrl: './help-shopify-product.component.html',
  styleUrls: ['./help-shopify-product.component.scss']
})
export class HelpShopifyProductComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
